import PageHeader from "./PageHeader";
import { Box } from "@mui/material";
import { primaryColor, secondaryColor } from "../constants/constants";
import useScreenSize from "../hooks/useScreenSize";

interface IProps {
  sectionTitle: string;
  body?: string;
  title: string;
}

const BannerComponent = (props: IProps) => {
  const { isLessThanMd } = useScreenSize();
  const { sectionTitle, title, body } = props;

  return (
    <Box
      className=""
      sx={{
        border: "0px solid red",
        display: "flex",
        background: "#75ace46b",
        borderRadius: "40px",
        flexDirection: "column",
        padding: isLessThanMd ? "10px" : "2rem 6rem",
        placeContent: "center",
        minHeight: "300px",
      }}
    >
      <span
        style={{
          color: secondaryColor,
          display: "block",
          fontSize: "16px",
          fontWeight: "600",
          letterSpacing: "1px",
          marginBottom: "22px",
          textTransform: "uppercase",
          fontFamily: `'Montserrat', sans-serif`,
          textAlign: "center",
        }}
      >
        {sectionTitle}
      </span>
      <PageHeader title={title} />
      {body && (
        <p
          style={{
            fontSize: "1.5625rem",
            fontWeight: "500",
            lineHeight: "2rem",
            textAlign: "center",
            color: primaryColor,
            marginTop: "1rem",
          }}
        >
          {body}
        </p>
      )}
    </Box>
  );
};

export default BannerComponent;
